import React from 'react'
import styles from './FloatingButton.scss'
import classNames from 'classnames'

export const FloatingButton = ({children, className}) => (
  <div className={classNames(styles.floatingButtonSpace, className)}>{children}</div>
)
